import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import union from 'lodash/union';
import { rejected, resolved } from 'store/createAction';
import {
  CREATE_GROUP,
  DELETE_GROUP,
  GET_GROUPS,
  GET_GROUP_DETAILS,
  GET_GROUP_MEMBERS_COUNT,
  RESTORE_GROUP,
  UPDATE_GROUP,
} from '../types';

const initialState = {
  loading: false,
  loadingGroup: false,
  entities: {},
  groupMembersCount: {},
  ids: [],
  limit: 30,
  offset: 0,
  hasMore: true,
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_GROUPS:
      return {
        ...state,
        loading: true,
      };

    case GET_GROUP_DETAILS: {
      return {
        ...state,
        loadingGroup: true,
      };
    }
    case resolved(GET_GROUP_DETAILS): {
      const ids = map(payload, 'hash');
      const entities = keyBy(payload, 'hash');
      return {
        ...state,
        loadingGroup: false,
        ids: union(state.ids, ids),
        entities: { ...state.entities, ...entities },
      };
    }
    case resolved(GET_GROUPS): {
      const ids = map(payload, 'hash');
      const entities = keyBy(payload, 'hash');
      if (meta.reset) {
        return {
          ...state,
          loading: false,
          ids,
          entities: {
            ...state.entities,
            ...entities,
          },
          offset: 0,
          limit: meta.query.limit,
          hasMore: payload.length === meta.query.limit,
        };
      }
      return {
        ...state,
        loading: false,
        ids: union(state.ids, ids),
        entities: { ...state.entities, ...entities },
        offset: meta.query.offset,
        hasMore: payload.length === meta.query.limit,
      };
    }

    case resolved(GET_GROUP_MEMBERS_COUNT): {
      return {
        ...state,
        groupMembersCount: {
          ...state.groupMembersCount,
          ...payload,
        },
      };
    }

    case resolved(CREATE_GROUP): {
      return {
        ...state,
        ids: [...state.ids, payload.hash],
        entities: {
          ...state.entities,
          [payload.hash]: payload,
        },
      };
    }

    case resolved(UPDATE_GROUP): {
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.hash]: payload,
        },
      };
    }

    case resolved(DELETE_GROUP):
    case resolved(RESTORE_GROUP): {
      const entities = state.entities;
      delete entities[meta.id];
      return {
        ...state,
        ids: state.ids.filter((id) => id !== meta.id),
        entities: {
          ...entities,
        },
      };
    }

    default:
      return state;
  }
};
